import { render } from "./BikeDetails.vue?vue&type=template&id=49937a36&scoped=true&ts=true"
import script from "./BikeDetails.vue?vue&type=script&lang=ts"
export * from "./BikeDetails.vue?vue&type=script&lang=ts"

import "./BikeDetails.vue?vue&type=style&index=0&id=49937a36&lang=scss&scoped=true"

import exportComponent from "/home/newbuyanyinsuran/public_html/wizards/car.buyanyinsurance.ae/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49937a36"]])

export default __exports__